const translations = {
  "en": {
    "%{var0} Forecast": "%{var0} Forecast",
    "No data available": "No data available",
    "View Detail": "View Detail"
  },
  "zh-tw": {
    "%{var0} Forecast": "%{var0} 預測",
    "No data available": "無可用資料",
    "View Detail": "查看細節"
  }
};

export default translations;
